import {ActionType} from "@src/store/ActionType";

export const UPLOAD_DATA_PARSE = new ActionType("UPLOAD_DATA_PARSE");